module.exports = __webpack_public_path__ + "static/img/1.89dcf39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos-en/1.jpg
// module id = TuIl
// module chunks = 0